import { all, call } from "redux-saga/effects";
import authSaga from "./handlers/authHandler";
import tempSaga from "./handlers/tempHandler";
import campaignSaga from "./handlers/campaignHandler";

const rootSaga = function* () {
  yield all([call(authSaga), call(tempSaga), call(campaignSaga)]);
};

export default rootSaga;
